import { render, staticRenderFns } from "./FileLabel.vue?vue&type=template&id=7e70798c&scoped=true&"
import script from "./FileLabel.vue?vue&type=script&lang=js&"
export * from "./FileLabel.vue?vue&type=script&lang=js&"
import style0 from "./FileLabel.vue?vue&type=style&index=0&id=7e70798c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e70798c",
  null
  
)

export default component.exports